import { ARTICLE_TYPE_IDS } from "../data/Constants"

interface RawArticleTypeLike {
    id?: unknown
    level2?: { id?: unknown }
}

/**
 * Whether an articleType counts as a "relevant" one for catalog/downloads purposes: luminaires,
 * generic articles, track and toolbox accessories. Everything else (plain accessories, electrical
 * connections, drivers, installation hardware...) is excluded. Works on the raw `{id, level2: {id}}`
 * shape as returned by sr-products/v3, so callers don't need to instantiate a domain element first —
 * `DomainElementsFilter.filterByRelevantArticleTypes` uses it for already-instantiated elements, and
 * apihub's collections provider/service use it directly on raw ERP/v3 JSON for the same rule.
 */
export function isRelevantArticleType(articleType: RawArticleTypeLike | undefined | null): boolean {
    if (!articleType) return true
    const rootId = articleType.id
    const level2Id = articleType.level2?.id
    return [ARTICLE_TYPE_IDS.luminaryId, ARTICLE_TYPE_IDS.genericId].includes(rootId as number)
        || [ARTICLE_TYPE_IDS.level2.trackId, ARTICLE_TYPE_IDS.level2.toolboxId].includes(level2Id as number)
}

export default {
    isRelevantArticleType,
}
